import axios from "axios";

const URL = process.env.REACT_APP_API_URL_UPLOAD + "purchasing/";

class UploadFilesService {
  upload(file, additionalData, type, onUploadProgress,) {
    let formData = new FormData()

    formData.append(type, file);
    formData.append('type', type);
    //   formData.append('user', 'mike');

    for (let d in additionalData) {
      formData.append(d, additionalData[d]);
    }

    return axios.post(URL + 'uploademailattachment', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress,
    });
  }
}
/* eslint import/no-anonymous-default-export: [2, {"allowNew": true}] */
export default new UploadFilesService();
